import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from '../../../environments/environment';
import packageJson from '../../../../package.json';

// App version — single source of truth is apps/web/package.json.
const APP_VERSION = packageJson.version;

// Environment badge: shown only outside production, so non-prod builds are
// identifiable at a glance in a clinical tool. null → hidden.
const ENV_LABEL: Record<string, string | null> = {
    local: 'LOCAL',
    dev: 'DEV',
    prod: null
};

@Component({
    standalone: true,
    selector: '[app-footer]',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div class="footer-side">
            <span class="text-muted-color text-sm">© {{ year }} Cyan Healthcare Group · Halifax, Nova Scotia. All rights reserved.</span>
        </div>
        <div class="footer-side footer-end">
            @if (envLabel) {
                <span class="env-badge" title="Environment"><span class="env-dot"></span>{{ envLabel }}</span>
            }
            <span class="text-muted-color text-sm">Cyan Blue · v{{ version }}</span>
        </div>
    `,
    host: {
        class: 'layout-footer'
    },
    styles: `
        .footer-side {
            display: flex;
            align-items: center;
            gap: 12px;
            min-width: 0;
        }
        .footer-end {
            justify-content: flex-end;
        }
        .env-badge {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            padding: 2px 9px;
            border-radius: 999px;
            background: var(--surface-hover);
            border: 1px solid var(--surface-border);
            font-size: 0.72rem;
            font-weight: 600;
            letter-spacing: 0.05em;
            color: var(--text-color-secondary);
        }
        .env-dot {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: var(--cb-warning, #f59e0b);
        }
    `
})
export class AppFooter {
    readonly year = new Date().getFullYear();
    readonly version = APP_VERSION;
    readonly envLabel = ENV_LABEL[environment.name] ?? null;
}
